<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 p-4 border-right mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectUsuario ? 'Agregar' : 'Editar'}} Usuario</label>
      </header>
      <form [formGroup]="formUsuario" (ngSubmit)="onOperarUsuario()">
        <div class="form-group" *ngIf="authService.getRolUser(adminSuper); else adminCC">
          <label class="small text-secondary font-weight-bold mt-2">Cámara de Comercio</label>
          <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
            <option class="" value="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}"
              [selected]="false">
              {{option?.desc_camara}}
            </option>
          </select>
        </div>
        <ng-template #adminCC>
          <div class="form-group">
            <label class="small text-secondary font-weight-bold mt-2">Cámara de Comercio</label>
            <label class="form-control form-control-sm bg-disabled">{{camaraComercio}}</label>
          </div>
        </ng-template>
        <div class="form-group">
          <label class="small text-secondary" for="tipo_usuario_id">Tipo de Usuario</label>
          <select class="form-control form-control-sm" id="tipo_usuario_id" formControlName="tipo_usuario_id">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of tipoUsuario; let i = index" value="{{option?.tipo_usuario_id}}"
              [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="usuario">Usuario</label>
          <input id="usuario" formControlName="usuario" type="text" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="correo_electronico">Correo Electrónico</label>
          <input id="correo_electronico" formControlName="correo_electronico" type="text"
            class="form-control form-control-sm">
        </div>
        <!-- <div class="form-group">
          <label class="small text-secondary" for="nit">Clave de Acceso</label>
          <input id="clave_acceso" formControlName="clave_acceso" type="text" class="form-control form-control-sm">
        </div>
     -->
        <!-- <div class="form-group">
          <button type="button" class="btn btn-primary w-100" (click)="onRestablecerContrasena()">Restablecer
            contraseña</button>
        </div> -->
        <ng-container *ngIf="formUsuario.value.tipo_usuario_id !== prestador || !formUsuario.value.tipo_usuario_id">
          <div class="form-group">
            <label class="small text-secondary" for="nombres">Nombres</label>
            <input id="nombres" formControlName="nombres" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="apellidos">Apellidos</label>
            <input id="apellidos" formControlName="apellidos" type="text" class="form-control form-control-sm">
          </div>
        </ng-container>
        <div class="form-group">
          <label for="tipo_identificacion" class="small text-secondary" for="tipo_identificacion_id">Tipo
            identificación</label>
          <select id="tipo_identificacion" formControlName="tipo_identificacion_id" class="form-control">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <ng-container *ngFor="let item of tipos_identificaciones">
              <option [ngValue]="item.tipo_identificacion_id" [selected]="false">{{item.descripcion}}</option>
            </ng-container>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="numero_identificacion">Número identificación</label>
          <input id="numero_identificacion" formControlName="numero_identificacion" type="text"
            class="form-control form-control-sm">
        </div>

         <div *ngIf="authService.getRolUser(adminSuper) || authService.getRolUser(adminCC1)" >

        <div class="form-group" [formGroup] = "formDv" *ngIf="selectUsuario">
          <input type="hidden" id="numero_identificacion2" formControlName="numero_identificacion2">
          <label class="small text-secondary" for="digito_verificacion">Digito verificaciòn</label>
          <input id="digito_verificacion"  type="text" class="form-control form-control-sm" formControlName="digito_verificacion">

          <span class="text-danger" *ngIf="formDv.get('digito_verificacion')?.hasError('required') && (formDv.get('digito_verificacion').touched || formDv.get('digito_verificacion').dirty)">
           * El campo es requerido
          </span>
          <span class="text-danger" *ngIf="formDv.get('digito_verificacion')?.hasError('maxlength') && (formDv.get('digito_verificacion').touched || formDv.get('digito_verificacion').dirty)">
           * Se admite solo un digito <br>
          </span>
          <span class="text-danger" *ngIf="formDv.get('digito_verificacion')?.hasError('pattern')  && (formDv.get('digito_verificacion').touched || formDv.get('digito_verificacion').dirty)">
            * Dígite únicamente valores numéricos  <br>
            </span>
           <span class="text-danger" *ngIf="formDv.hasError('identityRevealed')">
          * El digito de verificacion es incorrecto <br>
          </span>
          <div *ngIf="formDv.hasError('identityRevealed')">
             <div>
              <img src="../../../../../../../../assets/icons/refresh_perfil.png" class="float-right pointer"  height="25"  (click)="onclickCalcularDV()" />
            </div>
          </div>
        </div>
      </div>
        <ng-container *ngIf="!isPrestadorSeleccionado; else isPrestadorSeleccionadoTempl">
          <div class="form-group">
            <label class="small text-secondary" for="cargo">Cargo</label>
            <input id="cargo" formControlName="cargo" type="text" class="form-control form-control-sm">
          </div>
        </ng-container>
        <ng-template #isPrestadorSeleccionadoTempl>
          <div class="form-group">
            <label class="small text-secondary" for="cargo">Cargo</label>
            <select class="form-control form-control-sm" id="tipo_prestador_id" formControlName="tipo_prestador_id">
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option class="" *ngFor="let option of tipoPrestador; let i = index"
                [ngValue]="option?.tipo_prestador_id">
                {{option?.tipo_prestador_descripcion}}
              </option>
            </select>
          </div>
        </ng-template>
        <div class="form-group">
          <label class="small text-secondary" for="activo">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-group" *ngIf="selectUsuario && authService.getRolUser(adminSuper) ">
          <label class="small text-secondary" for="nit">Contraseña</label>
          <input id="clave_acceso" formControlName="clave_acceso" type="password" class="form-control form-control-sm">
          <div *ngIf="formUsuario.controls['clave_acceso'].value != '' && formUsuario.get('clave_acceso').errors">
            Usa al menos 8 carácteres, un carácter especial (%$+!.), una mayúscula y un número.
          </div>
        </div>
        <div class="form-row mt-2">
               <button type="button" class="btn btn-outline-primary border-0 m-auto" (click)="limpiarUsuario()">Limpiar</button>
         <div *ngIf="authService.getRolUser(adminSuper) || authService.getRolUser(adminCC1) else mostrar" >
            <button class="btn btn-primary m-auto " [disabled]="!formUsuario.valid || !formDv.valid" type="submit">{{!selectUsuario ? 'Agregar' : 'Editar'}}</button>
          </div>
          <ng-template #mostrar>
            <button class="btn btn-primary m-auto " [disabled]="!formUsuario.valid" type="submit">{{!selectUsuario ? 'Agregar' : 'Editar'}} </button>
          </ng-template>
        </div>
      </form>
    </section>


    <section class="col-9 p-4 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de Usuarios</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group" *ngIf="authService.getRolUser(adminSuper)">
                  <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                  <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                    <option class="" value="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of camarasLista; let i = index"
                      value="{{option?.codigo_camara}}" [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
                </div>

                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_usuario_id">Tipo de Usuario</label>
                  <select class="form-control form-control-sm" id="tipo_usuario_id" formControlName="tipo_usuario_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipoUsuario; let i = index"
                      value="{{option?.tipo_usuario_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="numero_identificacion">Número de identificación</label>
                  <input id="numero_identificacion" formControlName="numero_identificacion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="usuario">Usuario</label>
                  <input id="usuario" formControlName="usuario" type="text" class="form-control form-control-sm">
                </div>
                <!-- <div class="col-2 form-group">
                  <label class="small text-secondary" for="nombres">Nombre</label>
                  <input id="nombres" formControlName="nombres" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="apellidos">Apellido</label>
                  <input id="apellidos" formControlName="apellidos" type="text" class="form-control form-control-sm">
                </div> -->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="correo_electronico">Correo Electrónico</label>
                  <input id="correo_electronico" formControlName="correo_electronico" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="cargo">Cargo</label>
                  <input id="cargo" formControlName="cargo" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="activo">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerUsuario" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
          class="table-responsive"  style="text-align: center;">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.desc_camara	}}</td>
            <td>{{item.desc_tipo_usuario}}</td>
            <td>{{item.usuario}}</td>
            <td>{{item.apellidos ? item.nombres + ' ' + item.apellidos : item.nombres  }}</td>
            <td>{{item.correo_electronico}}</td>
            <td>{{item.desc_tipo_identificacion}}</td>
            <td>{{item.numero_identificacion}}</td>
            <td>{{item.digito_verificacion}}</td>
            <td>{{item.cargo}}</td>
            <td>{{item.fecha_ultima_autenticacion | date:'d/MMM/yyyy, h:mm a'}}</td>
            <td>{{item.fecha_creacion | date:'d/MMM/yyyy, h:mm a'}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarUsuario(item)">
              <!-- <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25" (click)="onEliminarUsuario(item)"> -->
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
